import Aboutus from './Aboutus';

export default Aboutus;